<template>
  <div class="organization">
    <!-- <h1>acquirer</h1> -->
    <v-snackbar
      v-model="snackbar"
      :timeout="6000"
      :color="snackbar_color"
      location="top"
      max-height="10cm"
      max-width="5cm"
      multi-line
    >
      {{ snackbar_text }}
    </v-snackbar>

    <v-row no-gutters class="mt-2">
      <v-col cols="auto" class="me-auto">
        <!-- <v-sheet class="ma-2 pa-2">Acquirer</v-sheet> -->
        <v-sheet>
          <v-breadcrumbs
            :items="[
              { text: $t('transaction operation'), disabled: true, href: '/' },
            ]"
          ></v-breadcrumbs>
        </v-sheet>
      </v-col>
      <v-col cols="auto">
        <v-sheet>
          <!-- <v-btn class="text-none text-subtitle-1" color="#5865f2" size="small" variant="flat" >Add Acquirer</v-btn>             -->
          <!-- <v-btn density="compact">Add Acquirer</v-btn>  -->
          <v-btn
            class="button_size"
            prepend-icon="mdi-plus"
            color="blue"
            @click="compose"
            v-if="
              this.global_permissions.includes('ROLE_STAFF_ADMIN') ||
              this.global_permissions.includes('ROLE_STAFF_USER')
            "
          >
            <template v-slot:prepend>
              <v-icon color="white"></v-icon>
            </template>
            {{ $t("add_transaction_operation") }}
          </v-btn>
        </v-sheet>
      </v-col>
    </v-row>

    <v-row class="search_row">
      <v-col cols="4">
        <v-text-field
          append-inner-icon="mdi-close-circle"
          append-icon="mdi-magnify"
          density="compact"
          :label="$t('search')"
          variant="solo"
          hide-details
          single-line
          dense
          v-model="query"
          @click:append-inner="resetData"
          @click:append="searchData"
        ></v-text-field>
      </v-col>
      <v-col cols="4"> </v-col>
    </v-row>

    <!-- Loading Spinner -->
    <v-progress-circular
      v-if="loading"
      indeterminate
      color="blue"
      size="25"
      class="loading-spinner"
    ></v-progress-circular>

    <v-card v-else>
      <v-data-table
        :headers="headers"
        :items="operations"
        class="elevation-1 custom-table-style"
        :search="search"
        :items-per-page="itemsPerPage"
        :items-length="totalItems"
        disable-pagination
        :hide-default-footer="true"
        :fixed-header="true"
        :loading="loading"
      >
        <template v-slot:item.actions="{ item }">
          <v-tooltip :text="$t('Update')" location="top">
            <template v-slot:activator="{ props }">
              <v-icon
                v-bind="props"
                small
                class="mr-2"
                color="green"
                @click="compose_update(item.raw.id)"
                v-if="
                  this.global_permissions.includes('ROLE_STAFF_ADMIN') ||
                  this.global_permissions.includes('ROLE_STAFF_USER')
                "
                >mdi-pencil-circle</v-icon
              >
            </template>
          </v-tooltip>
          <v-tooltip :text="$t('Delete')" location="top">
            <template v-slot:activator="{ props }">
              <v-icon
                v-bind="props"
                small
                class="mr-2"
                color="red"
                @click="compose_delete(item.raw.id)"
                v-if="this.global_permissions.includes('ROLE_STAFF_ADMIN')"
                >mdi-delete-circle</v-icon
              >
            </template>
          </v-tooltip>
        </template>
        <template v-slot:bottom>
          <div class="text-center pt-2">
            <v-pagination
              v-model="page"
              :length="pageCount"
              total-visible="7"
              @update:model-value="page"
            ></v-pagination>
          </div>
        </template>
      </v-data-table>
    </v-card>

    <!-- ADD DIALOG -->
    <v-dialog v-model="dialog" persistent width="800">
      <v-card>
        <v-form v-model="form" @submit.prevent="onSubmit">
          <v-container>
            <v-card-title>
              <span class="text-h5">{{ $t("add_transaction_operation") }}</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                     :label="$t('operation_name')"
                      :readonly="loading"
                      :rules="[required, validateName]"
                      clearable
                      v-model="operation_data.f_operationName"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      :label="$t('operation_code')"
                      :readonly="loading"
                      :rules="[required, validateCode]"
                      clearable
                      v-model="operation_data.f_operationCode"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-select
                      :items="organization"
                      item-title="orgName"
                      item-value="orgId"
                      :label="$t('Select Organization')"
                      :rules="[required]"
                      v-model="operation_data.f_orgId"
                    ></v-select>
                  </v-col>
                </v-row>
              </v-container>
              <small>*{{ $t("indicateRequires") }}</small>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn variant="text" @click="dialog = false">{{
            $t("Close")
          }}</v-btn>
              <v-btn
                color="success"
                type="submit"
                variant="text"
                @click="addOperation"
                >{{ $t("Save") }}</v-btn
              >
            </v-card-actions>
          </v-container>
        </v-form>
      </v-card>
    </v-dialog>
    <!-- END ADD DIALOG -->

    <!-- UPDATE  DIALOG -->
    <v-dialog v-model="dialog_update" persistent width="800">
      <v-card>
        <v-form v-model="form" @submit.prevent="onSubmit">
          <v-container>
            <v-card-title>
              <span class="text-h5">{{ $t("update_transaction_operation") }}</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                       :label="$t('operation_name')"
                      :readonly="loading"
                      :rules="[required, validateName]"
                      clearable
                      v-model="operation_data.f_operationName"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12">
                    <v-text-field
                      :label="$t('operation_code')"
                      :readonly="loading"
                      :rules="[required, validateCode]"
                      clearable
                      v-model="operation_data.f_operationCode"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12">
                    <v-select
                      :items="organization"
                      item-title="orgName"
                      item-value="orgId"
                      :label="$t('Select Organization')"
                      :rules="[required]"
                      v-model="operation_data.f_orgId"
                    ></v-select>
                  </v-col>
                </v-row>
              </v-container>
              <small>*{{ $t("indicateRequires") }}</small>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn variant="text" @click="dialog_update = false">{{
            $t("Close")
          }}</v-btn>
              <v-btn
                color="success"
                type="submit"
                variant="text"
                @click="updateOperation"
                >{{ $t("Update") }}</v-btn
              >
            </v-card-actions>
          </v-container>
        </v-form>
      </v-card>
    </v-dialog>
    <!-- END UPDATE  DIALOG -->

    <!-- DELETE  DIALOG -->
    <!-- <v-dialog
              v-model="dialog_delete"
              persistent
              width="500"
            >              
              <v-card>
                <v-card-title>
                  <span class="text-h5">do you want to delete?</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                                           
                    </v-row>
                  </v-container>
                  
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue-darken-1" variant="text" @click="dialog_delete = false">Close</v-btn>                 
                  <v-btn color="blue-darken-1" variant="text" @click="deleteOperation">Delete</v-btn>                 
                </v-card-actions>
              </v-card>
            </v-dialog> -->

    <v-dialog v-model="dialog_delete" persistent width="400">
      <v-card>
        <template v-slot:title>
          <span class="font-weight-medium-black">{{ $t("deleteFile") }}</span>
        </template>

        <v-card-text class="bg-surface-light py-4">
          {{ $t("deleteText") }}
        </v-card-text>
        <v-card-actions class="mb-2 mr-2">
          <v-spacer></v-spacer>
          <v-btn color="red" variant="flat" @click="deleteOperation">{{
            $t("Delete")
          }}</v-btn>
          <v-btn variant="flat" @click="dialog_delete = false">{{
            $t("Close")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- END UPDATE DIALOG -->
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "Operations",
  props: {
    msg: String,
  },
  data() {
    return {
      name: "",
      emits: ["reload"],
      operations: [], //used
      organization: [],

      dialog: false,
      dialog_update: false,
      dialog_delete: false,

      operation_data: {
        //used
        f_operationName: "",
        f_operationCode: "",
        f_orgId: "",
      },

      operationId: "",
      search: "",
      headers: [
        /* {
            title: 'ID',
            align: 'start',
            sortable: false,
            key: 'operationId',
          }, */
        { title: this.$t("operation_name"), key: "operationName" },
        { title: this.$t("operation_code"), key: "operationCode" },
        { title: this.$t("Organization"), key: "organization.orgName" },
        { title: this.$t("Actions"), key: "actions", sortable: false },
      ],

      //form
      form: false,
      loading: false,

      //snackbar
      snackbar: false,
      snackbar_text: "",
      snackbar_color: "",

      //pagination
      page: 1,
      itemsPerPage: 5,
      totalItems: 0,
      totalPages: 0,
      query: "",
    };
  },

  computed: {
    pageCount() {
      //console.log("ssss", this.totalItems + " / " + this.itemsPerPage);
      return Math.ceil(this.totalItems / this.itemsPerPage);
    },
  },

  watch: {
    page(newPage) {
      this.page = newPage;
      this.fetchData();
      //console.log("new page", this.page);
    },

    onUpdatePageHandler(newPage) {
      this.page = newPage;
      //this.fetchData()
    },

    onItemsPerPageChange(newItemsPerPage) {
      this.itemsPerPage = newItemsPerPage;
      this.fetchData();
    },

    //auto-complete
    search(newSearch) {
      if (newSearch.length >= 2) {
        this.searchCountry(newSearch);
      } else {
        this.countries = [];
      }
    },
  },

  created() {},

  methods: {
    onSubmit() {
      if (!this.form) return;
    },

    required(v) {
      return !!v || "Field is required";
    },

    resetData() {
      this.query = "";
      this.fetchData();
    },

    resetInput() {
      this.operation_data.f_operationName = "";
      this.operation_data.f_operationCode = "";
      this.operation_data.f_orgId = "";
    },

    show_toast(status, color, text) {
      this.snackbar = status;
      this.snackbar_color = color;
      this.snackbar_text = text;
    },

    compose() {
      this.dialog = true;
      this.resetInput();
      this.checkTokenExpiry();
      this.requests_handler();
    },

    compose_update(id) {
      this.operationId = id;
      this.dialog_update = true;
      this.checkTokenExpiry();
      // console.log("id", id);
      this.requests_handler2();
    },

    compose_delete(id) {
      this.operationId = id;
      this.dialog_delete = true;
    },

    requests_handler() {
      axios
        .all([
          axios.get(window.baseurl + "organizations", {
            headers: { Authorization: "Bearer " + this.accessToken },
          }),
        ])
        .then(
          axios.spread((org_response) => {
            // console.log("data1", org_response.data);
            if (org_response.status == 200) {
              this.organization = []; //remove all items from array

              if (
                this.global_permissions.includes(
                  "ROLE_STAFF_ADMIN",
                  "ROLE_STAFF_USER"
                )
              ) {
                let i = 0;
                this.organization = []; //remove all items from array
                for (i = 0; i < org_response.data.records.length; i++) {
                  this.organization.push({
                    orgId: org_response.data.records[i].id,
                    orgName: org_response.data.records[i].orgName,
                  });
                }
              }
            }
          })
        );
    }, //end of requests_handler method

    async addOperation() {
      //this.dialog = false
      this.checkTokenExpiry();
      // console.log("form data", this.operation_data);
      try {
        let result = await axios.post(
          window.baseurl + "" + "operations",
          {
            operationName: this.operation_data.f_operationName,
            operationCode: this.operation_data.f_operationCode,
            organization_id: this.operation_data.f_orgId,
            createdBy: this.userEmail,
            updatedBy: this.userEmail,
          },
          { headers: { Authorization: "Bearer " + this.accessToken } }
        );

        if (result.status == 201) {
          //this.show_toast(true, "success", "Successful");
          this.$root.vtoast.show({ message: this.$t("activity") });
          window.setInterval(() => {
            this.dialog = false;
            this.$emit("reload");
          }, this.wainting_time);
        }
      } catch (error) {
        //this.show_toast(true, "warning", error.message);
        if (error.response.status == 417) {
          this.$root.vtoast.showError({ message: error.response.data.message });
        } else if (error.response.status == 500) {
          this.$root.vtoast.showError({ message: error.response.data.detail });
        } else {
          this.$root.vtoast.showError({ message: error.response.data.message });
        }
      }
    },

    requests_handler2() {
      axios
        .all([
          axios.get(window.baseurl + "" + "operations/" + this.operationId, {
            headers: { Authorization: "Bearer " + this.accessToken },
          }),
          axios.get(window.baseurl + "organizations", {
            headers: { Authorization: "Bearer " + this.accessToken },
          }),
        ])
        .then(
          axios.spread((operation_response, org_response) => {
            //console.log("data1", operation_response.data);

            //get data for selected id and display data in for dialog
            if (operation_response.status == 200) {
              //this.acquirer_response = acquirer_response.data,
              //console.log("operation Data", this.operation_response);
              this.operation_data.f_operationName =
                operation_response.data.operationName;
              this.operation_data.f_operationCode =
                operation_response.data.operationCode;
              this.operation_data.f_orgId =
                operation_response.data.organization.id;
            }

            if (org_response.status == 200) {
              this.organization = []; //remove all items from array

              if (
                this.global_permissions.includes(
                  "ROLE_STAFF_ADMIN",
                  "ROLE_STAFF_USER"
                )
              ) {
                let i = 0;
                this.organization = []; //remove all items from array
                for (i = 0; i < org_response.data.records.length; i++) {
                  this.organization.push({
                    orgId: org_response.data.records[i].id,
                    orgName: org_response.data.records[i].orgName,
                  });
                }
              }
            }
          })
        );
    }, //end of requests_handler 2 method

    async updateOperation() {
      //this.dialog_update = false
      // console.log("update form operation id", this.operationId);
      // console.log("update form operation..", this.operation_data);
      try {
        let result = await axios.put(
          window.baseurl + "" + "operations/" + this.operationId,
          {
            operationName: this.operation_data.f_operationName,
            operationCode: this.operation_data.f_operationCode,
            organization_id: this.operation_data.f_orgId,
            updatedBy: this.userEmail,
          },
          { headers: { Authorization: "Bearer " + this.accessToken } }
        );
        // console.log("update form operation result", result);
        if (result.status == 200) {
          //this.show_toast(true, "success", "Successful");
          // this.$root.vtoast.show({message: result.data.message})
          this.$root.vtoast.show({ message: this.$t("operation_updated") });
          window.setInterval(() => {
            this.dialog_update = false;
            this.$emit("reload");
          }, this.wainting_time);
        }
      } catch (error) {
        //this.show_toast(true, "warning", error.message);
        if (error.response.status == 417) {
          this.$root.vtoast.showError({ message: error.response.data.message });
        } else if (error.response.status == 500) {
          this.$root.vtoast.showError({ message: error.response.data.detail });
        } else {
          this.$root.vtoast.showError({ message: error.response.data.message });
        }
      }
    },

    async deleteOperation() {
      this.dialog_delete = false;
      try {
        let result = await axios.delete(
          window.baseurl + "" + "operations/" + this.operationId,
          { headers: { Authorization: "Bearer " + this.accessToken } }
        );
        if (result.status == 204) {
          //alert("successfull deleted");
          //this.show_toast(true, "success", "Deleted");
          // this.$root.vtoast.show({message: result.data.message})
          this.$root.vtoast.show({ message: this.$t("operation_deleted") });
          window.setInterval(() => {
            // this.$emit("reload")
            this.fetchData();
          }, this.waiting_time);
        }
      } catch (error) {
        //this.show_toast(true, "warning", error.message);
        this.$root.vtoast.showError({ message: error.message });
      }
    },

    async fetchData() {
      let result;
      let page2 = this.page - 1;
      this.loading = true;
      try {
        if (
          this.global_permissions.includes("ROLE_STAFF_ADMIN") ||
          this.global_permissions.includes("ROLE_STAFF_USER")
        ) {
          result = await axios.get(window.baseurl + "operations", {
            params: { page: page2, pagesize: 100 },
            headers: { Authorization: "Bearer " + this.accessToken },
          });

          // console.log("operations_object", result);
          this.operations = result.data.records;
          this.totalItems = result.data.totalRecords;
          this.itemsPerPage = result.data.pageSize;
          this.totalPages = result.data.totalPages;
          this.loading = false;
        } else if (
          this.global_permissions.includes("ROLE_USER_ADMIN") ||
          this.global_permissions.includes("ROLE_USER_ASSIST")
        ) {
          result = await axios.get(
            window.baseurl + "operations/org/" + this.orgId,
            {
              params: { page: page2, pagesize: 100 },
              headers: { Authorization: "Bearer " + this.accessToken },
            }
          );

          //console.log("user_object", result);
          this.operations = result.data.records;
          this.totalItems = result.data.totalRecords;
          this.itemsPerPage = result.data.pageSize;
          this.totalPages = result.data.totalPages;
          this.loading = false;
        }
      } catch (error) {
        //this.show_toast(true, "warning", error.message);
        this.$root.vtoast.showError({ message: error.message });
        this.loading = false;
      }
    },

    async searchData() {
      // console.log("in searchData", this.query);
      this.checkTokenExpiry();
      let result;
      this.loading = true;
      let page2 = this.page - 1;
      try {
        if (
          this.global_permissions.includes("ROLE_STAFF_ADMIN") ||
          this.global_permissions.includes("ROLE_STAFF_USER")
        ) {
          result = await axios.get(window.baseurl + "operations/search", {
            params: { page: page2, search: this.query },
            headers: { Authorization: "Bearer " + this.accessToken },
          });

          // console.log("operations_object", result);
          this.operations = result.data.records;
          this.totalItems = result.data.totalRecords; // Set the total number of items
          this.itemsPerPage = result.data.pageSize;
          this.totalPages = result.data.totalPages;

          this.loading = false;
        }
        if (
          this.global_permissions.includes("ROLE_USER_ADMIN") ||
          this.global_permissions.includes("ROLE_USER_ASSIST")
        ) {
          result = await axios.get(
            window.baseurl + "operations/org/search/" + this.orgId,
            {
              params: { page: page2, search: this.query },
              headers: { Authorization: "Bearer " + this.accessToken },
            }
          );
          // console.log("operations_object", result);
          this.operations = result.data.records;
          this.totalItems = result.data.totalRecords; // Set the total number of items
          this.itemsPerPage = result.data.pageSize;
          this.totalPages = result.data.totalPages;

          this.loading = false;
        }
      } catch (error) {
        //this.show_toast(true, "warning", error.message);
        this.$root.vtoast.showError({ message: error.message });
        this.loading = false;
      }
    },

    /*RULES VALIDATION */

    validateName(value) {
      const regex = /^[A-Za-z0-9_.+\- ]+$/;
      return (
        regex.test(value) ||
        "Name can only be numbers, characters, space, underscore and . - +"
      );
    },
    validateCode(value) {
      const regex = /^[0-9]{3}$/;
      return (
        regex.test(value) ||
        "Operation Code can only be 3 characters long and numbers."
      );
    },
  },
  //get list of acquirers
  async mounted() {
    this.checkTokenExpiry();

    //get data for table
    this.fetchData();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
